/**
 * @fileoverview GET handler for the "/api/calculated_filters/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiCalculatedFiltersAppGroupId } from "./constants";
import type { ApiCalculatedFiltersAppGroupIdParams, GetApiCalculatedFiltersAppGroupIdResult } from "./types";
import { isGetApiCalculatedFiltersAppGroupIdResult } from "./validators";

export const getApiCalculatedFiltersAppGroupId = reactQueryTableFetcherAdapter(
  apiCalculatedFiltersAppGroupId,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: ApiCalculatedFiltersAppGroupIdParams
  ): Promise<GetApiCalculatedFiltersAppGroupIdResult> => {
    return fetch(
      `/api/calculated_filters/${appGroupId}`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isGetApiCalculatedFiltersAppGroupIdResult
);
